import React, { Fragment, useEffect } from 'react'
import { Field } from 'redux-form'
import { connect } from 'react-redux'
import { requestStateOptions } from '../../../actions/stateOptions'
import { renderTextField } from './fields'
import { required } from './validators'
import { renderSelectField } from './fields'

const Contact = props => {
  useEffect(() => {
    if (!props.isLoading && !props.options && !props.hasErrors) {
      props.requestStateOptions()
    }
  })
  const stateOptions = [
    {
      value: '',
      label: 'Choose your state/province'
    }
  ]
  props.options &&
    props.options.forEach(option => {
      stateOptions.push({
        value: option.code,
        label: option.name
      })
    })

  return (
    <>
      <div className="equote-package-additional-details-form--contact-name">
        <label>
          NAME
          {props.canUsePromoQualifiers && (
            <Fragment>
              {' '}
              AND
              <br /> LOCATION <span style={{ color: 'red' }}>*</span>
            </Fragment>
          )}
        </label>
        <div className="equote-package-additional-details-form--contact-name--container">
          <Field
            name="First Name"
            type="text"
            component={renderTextField}
            inputClassName="equote-package-additional-details-form--textInput"
            label="First Name"
            validate={required}
            groupClassName="equote-package-additional-details-form--input-contact-name"
          />
          <Field
            name="Last Name"
            type="text"
            component={renderTextField}
            inputClassName="equote-package-additional-details-form--textInput"
            label="Last Name"
            validate={required}
            groupClassName="equote-package-additional-details-form--input-contact-name"
          />
          {props.canUsePromoQualifiers && (
            <Field
              name="State or Province"
              type="select"
              component={renderSelectField}
              inputClassName="equote-package-additional-details-form--textInput"
              validate={required}
              groupClassName="equote-package-additional-details-form--input-contact-name"
              options={stateOptions}
            />
          )}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.stateOptions.isLoading,
  options: state.stateOptions.items,
  canUsePromoQualifiers: !!ownProps.canUsePromoQualifiers
})

const mapDispatchToProps = dispatch => ({
  requestStateOptions() {
    dispatch(requestStateOptions(['USA', 'CAN']))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact)
